var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86332 12C5.58732 12 5.32332 11.886 5.13432 11.685L0.271321 6.50599C-0.107679 6.10399 -0.086679 5.47099 0.315321 5.09299C0.718321 4.71499 1.35132 4.73499 1.72832 5.13699L5.85332 9.52799L14.2613 0.325991C14.6353 -0.0830093 15.2673 -0.110009 15.6753 0.261991C16.0823 0.633991 16.1103 1.26699 15.7383 1.67399L6.60132 11.674C6.41432 11.88 6.14832 11.998 5.87032 12H5.86332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.10a49d8d76f69e791404238d1ed04533.svg";
export { ForwardRef as ReactComponent };